import { IS_LOADING } from '@/store/types/root/actions-types';
import { POINTS_CREATE_REQUEST, POINTS_UPDATE_REQUEST, POINTS_DELETE_REQUEST, GET_POINTS_REQUEST,GET_MY_POINTS_HISTORY_REQUEST, GET_LEADERBOARD_POINTS_REQUEST, MY_POINTS_OVERVIEW_REQUEST, GET_ALL_TIME_LEADERBOARD_POINTS_REQUEST } from './action-types';
import {ADD_POINTS_TO_LIST, ADD_POINT_TO_LIST, DELETE_POINTS_FROM_LIST, UPDATE_POINTS_IN_LIST, ADD_LEADERBOARD_POINTS_TO_LIST,ADD_ALL_TIME_LEADERBOARD_POINTS_TO_LIST, ADD_MY_POINTS_OVERVIEW, ADD_SINGLE_POINT_TO_LEADERBOARD_POINT_LIST} from "./mutation-types"
import api from "@/api/api"
import showMessage from "@/utils/alert"

export default {

    [GET_POINTS_REQUEST]: async ({  commit }, userID)=>{
        let response = {}
        try {
            response =   await api.post("/rewards/history", {user_id: userID})
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                reponseBody.forEach(point => {
                    point.category_object = point.category;
                    point.sub_category_object = point.sub_category;
                    point.given_by_object =  point.given_by;
                    point.receiver_object = point.given_to; 

                    point.category = point.category.name
                    point.sub_category = point.sub_category.name
                    point.given_by =  point.given_by.fname  + " " + point.given_by.lname
                    point.receiver = point.given_to.fname  + " " + point.given_to.lname
                    point.date =  point.created_at.split(",")[0]
                });
                commit(ADD_POINTS_TO_LIST, reponseBody)
            }
        } catch (err) {
            console.log(err)
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },


    [GET_MY_POINTS_HISTORY_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.post("/rewards/history")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                reponseBody.forEach(point => {
                    point.category_object = point.category;
                    point.sub_category_object = point.sub_category;
                    point.given_by_object =  point.given_by;
                    point.receiver_object = point.given_to; 

                    point.category = point.category.name
                    point.sub_category = point.sub_category.name
                    point.given_by =  point.given_by.fname  + " " + point.given_by.lname
                    point.receiver = point.given_to.fname  + " " + point.given_to.lname
                    point.date =  point.created_at.split(",")[0]
                });
                commit(ADD_POINTS_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [POINTS_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        if(body.id)
            delete body.id
            
        try {
            response =   await api.post("/rewards", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if(response.data.body === "Reward Points Granted.")
                    commit(ADD_POINT_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [POINTS_UPDATE_REQUEST]: async ({state, commit }, body)=>{
        const lodash = require('lodash');
        let response = {}            
        let oldCategory = state.categoriesList.filter(item=>{ return item.id == body.id})
        oldCategory = oldCategory.length > 0 ? oldCategory[0] : {}
        const bodyDifference = lodash.omitBy(body, (value, key) => oldCategory[key] === value);
        try{
            response =   await api.put("/rewards/" + body.id, bodyDifference)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "Category Updated."){
                    commit(UPDATE_POINTS_IN_LIST, body)
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [POINTS_DELETE_REQUEST]: async ({ commit }, categoryIDs)=>{
        let response = {}
        try {
            response =   await api.post("/rewards/delete", {"ids": categoryIDs})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                if(reponseBody.message === "Category(s) Deleted." )
                 commit(DELETE_POINTS_FROM_LIST, categoryIDs)
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [GET_LEADERBOARD_POINTS_REQUEST]: async ({  commit }, date)=>{
        let response = {}
        try {
            response =   await api.get("/rewards/leaderboard/?date=" + date )
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_LEADERBOARD_POINTS_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [GET_ALL_TIME_LEADERBOARD_POINTS_REQUEST]: async ({  commit }, date="")=>{
        let response = {}
        try {
            response =   await api.get("/rewards/leaderboard" )
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_ALL_TIME_LEADERBOARD_POINTS_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [MY_POINTS_OVERVIEW_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =  await api.get("/rewards/points-overview")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_MY_POINTS_OVERVIEW, reponseBody)
            }
        } catch (err) {
        }
        return response
    },
}
